import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Define your custom colors once
const accentroColors = [
  // accentroGray
  'accentroGray-full',
  'accentroGray-800',
  'accentroGray-600',
  'accentroGray-500',
  'accentroGray-400',
  'accentroGray-300',
  'accentroGray-200',
  'accentroGray-100',
  'accentroGray-50',
  // accentroDarkGray
  'accentroDarkGray-full',
  // accentroAqua
  'accentroAqua-full',
  'accentroAqua-50',
  'accentroAqua-100',
  'accentroAqua-200',
  'accentroAqua-300',
  'accentroAqua-400',
  'accentroAqua-500',
  'accentroAqua-600',
  'accentroAqua-700',
  'accentroAqua-800',
  // others
  'accentroAquaLight-full',
  'accentroAquaVeryLight-full',
  'accentroSuccess-full',
  'accentroSuccessLight-full',
  'accentroYellowLight-full',
  'accentroSecondaryBrown-full',
  // accentroWhite
  'accentroWhite-full',
  'accentroWhite-50',
  'accentroWhite-100',
  'accentroWhite-200',
  'accentroWhite-500',
  // accentroRed
  'accentroRed-full',
  'accentroRed-100',
  // accentroError
  'accentroError-full',
  'accentroError-50',
  'accentroError-100',
  'accentroError-200',
  'accentroError-300',
  'accentroError-400',
  'accentroError-500',
  'accentroError-600',
  'accentroError-700',
  'accentroError-800',
  'accentroError-900',
  // misc
  'accentroDarkError-full',
  'accentroCream-full',
  'accentroAquaMidLight-full',
  'accentroLightYellow-full',
  'accentroLightGreen-full',
] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'bg-color': [{ bg: accentroColors }],
      'text-color': [{ text: accentroColors }],
      'border-color': [{ border: accentroColors }],
      'border-color-t': [{ 'border-t': accentroColors }],
      'border-color-r': [{ 'border-r': accentroColors }],
      'border-color-b': [{ 'border-b': accentroColors }],
      'border-color-l': [{ 'border-l': accentroColors }],
      'border-color-x': [{ 'border-x': accentroColors }],
      'border-color-y': [{ 'border-y': accentroColors }],
      'ring-color': [{ ring: accentroColors }],
      'ring-offset-color': [{ 'ring-offset': accentroColors }],
      fill: [{ fill: accentroColors }],
      stroke: [{ stroke: accentroColors }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const clsxMerge = (...inputs: ClassValue[]) => {
  return clsx(inputs)
}
